import "../css/style.scss";
import "../assets/js/lodash.js";

import Search from "./modules/Search";
import CommonScript from "./modules/common-script";

const search = new Search();

let lastKnowPosition = 0;
let pushUpButton = document.querySelector(".push-up");

//pushUP Button
document.addEventListener("scroll", function (e) {
  lastKnowPosition = window.scrollY;

  if (lastKnowPosition > 500) {
    pushUpButton.classList.remove("hidden");
  } else {
    pushUpButton.classList.add("hidden");
  }
});

pushUpButton.addEventListener("click", () => {
  window.scroll(0, 0);
});

//Ako na to? Varianty postupu

let variantButton = document.querySelectorAll(".variant-js");
let navodButton = document.querySelectorAll(".variant-js2");
let divContentPostup = document.querySelectorAll(".postupy-content2");
let navodContent = document.querySelectorAll(".navod-content");
let actualID;

let rodicButton = document.querySelector(".rodic");
let ucitelButton = document.querySelectorAll(".ucitel");
let ucitelTriedaButton = document.querySelectorAll(".ucitel-trieda");

variantButton.forEach((el) => {
  el.addEventListener("click", () => {
    variantButton.forEach((ele) => {
      if (ele.id == el.id) {
        ele.classList.remove("top-variant");
        ele.classList.add("top-variant-active");
        actualID = el.id;

        //if (ele.id == 732) {

        navodContent.forEach((navod) => {
          if (
            (actualID == 732 && navod.id == 1099) ||
            (actualID == 734 && navod.id == 1104) ||
            (actualID == 736 && navod.id == 1103) ||
            (actualID == 1110 && navod.id == 1112) ||
            (actualID == 1151 && navod.id == 1153)
          ) {
            navodButton.forEach((navod) => {
              if (
                navod.id == 1099 ||
                navod.id == 1104 ||
                navod.id == 1103 ||
                navod.id == 1112
              ) {
                navod.classList.add("variant-active");
                navod.classList.remove("bottom-variant");
              } else {
                navod.classList.remove("variant-active");
                navod.classList.add("bottom-variant");
              }
            });
            navod.classList.remove("hidden-postup");
          } else {
            navod.classList.add("hidden-postup");
          }
        });
      } else {
        ele.classList.remove("top-variant-active");
        ele.classList.add("top-variant");
      }
    });

    divContentPostup.forEach((elem) => {
      if (el.id == elem.id) {
        elem.classList.remove("hidden-postup");
      } else {
        elem.classList.add("hidden-postup");
      }
    });
  });

  navodButton.forEach((nav) => {
    nav.addEventListener("click", () => {
      //console.log(nav.id);

      navodContent.forEach((navod) => {
        if (navod.id == nav.id) {
          navod.classList.remove("hidden-postup");
          navodButton.forEach((tap) => {
            if (tap.id == nav.id) {
              tap.classList.add("variant-active");
              tap.classList.remove("bottom-variant");
            } else {
              tap.classList.remove("variant-active");
              tap.classList.add("bottom-variant");
            }
          });
        } else {
          navod.classList.add("hidden-postup");
        }
      });
    });
  });
});

try {
  rodicButton.addEventListener("click", () => {
    navodContent.forEach((navodObsah) => {
      if (navodObsah.id == 1100) {
        navodObsah.classList.remove("hidden-postup");
      } else {
        navodObsah.classList.add("hidden-postup");
      }
    });

    navodButton.forEach((navButt) => {
      if (navButt.id == 1100) {
        navButt.classList.add("variant-active");
        navButt.classList.remove("bottom-variant");
        window.scroll(0, 0);
      } else {
        navButt.classList.add("bottom-variant");
        navButt.classList.remove("variant-active");
      }
    });
  });

  ucitelButton.forEach((uc) => {
    uc.addEventListener("click", () => {
      navodContent.forEach((navodObsah) => {
        if (navodObsah.id == 1101) {
          navodObsah.classList.remove("hidden-postup");
        } else {
          navodObsah.classList.add("hidden-postup");
        }
      });

      navodButton.forEach((navButt) => {
        if (navButt.id == 1101) {
          navButt.classList.add("variant-active");
          navButt.classList.remove("bottom-variant");
          window.scroll(0, 0);
        } else {
          navButt.classList.add("bottom-variant");
          navButt.classList.remove("variant-active");
        }
      });
    });
  });

  ucitelTriedaButton.forEach((ut) => {
    ut.addEventListener("click", () => {
      navodContent.forEach((navodObsah) => {
        if (navodObsah.id == 1102) {
          navodObsah.classList.remove("hidden-postup");
        } else {
          navodObsah.classList.add("hidden-postup");
        }
      });

      navodButton.forEach((navButt) => {
        if (navButt.id == 1102) {
          navButt.classList.add("variant-active");
          navButt.classList.remove("bottom-variant");
          window.scroll(0, 0);
        } else {
          navButt.classList.add("bottom-variant");
          navButt.classList.remove("variant-active");
        }
      });
    });
  });
} catch {}

//raabe video
try {
  let vid = document.getElementById("raabeDigitalVideo");
  vid.defaultMuted = true;
  vid.controls = true;
  vid.volume = 0.0;

  let volume = document.getElementById("volume");
  volume.addEventListener("click", () => {
    if (vid.volume == 0.0) {
      volume.classList.remove("mute-inactive");
      vid.volume = 1.0;
    } else if (vid.volume == 1.0) {
      volume.classList.add("mute-inactive");
      vid.volume = 0.0;
    }
  });
} catch {}

//benefity videa

let benefitButton = document.querySelectorAll(".benefit-button");
let benefitText = document.querySelectorAll(".benefit-text-frame");
let vidBen = document.querySelectorAll("#benefit-video");
let allVidsBen = document.querySelectorAll(".benefit-video");
let idBen;

vidBen.forEach((video) => {
  video.defaultMuted = true;
  video.controls = true;
  video.volume = 0.0;
});

benefitButton.forEach((benButton) => {
  benButton.addEventListener("click", () => {
    idBen = benButton.id;

    allVidsBen.forEach((allVid) => {
      if (idBen == allVid.id) {
        allVid.classList.remove("benefit-no-display");
      } else {
        allVid.classList.add("benefit-no-display");
      }
    });

    benefitButton.forEach((but) => {
      if (idBen == but.id) {
        but.classList.add("active-benefit");
      } else {
        but.classList.remove("active-benefit");
      }
    });

    benefitText.forEach((benText) => {
      if (idBen == benText.id) {
        benText.classList.remove("benefit-no-display");
      } else {
        benText.classList.add("benefit-no-display");
      }
    });
  });
});
/*
//benefity responze videa
window.addEventListener(
  "resize",
  function (event) {
    let monitorPicture = document.querySelector(".monitor");
    let monitorHeight = monitorPicture.offsetHeight;
    let benefitVideo = document.querySelector(".benefit-video");
    let screenWidth = this.window.innerWidth;
    let numberChange = 739.6;

    // if (screenWidth >= 1200) {
    //   numberChange = 76;
    // }

    // if (screenWidth < 1200) {
    //   numberChange = 76 * 0.9;
    // }

    let reducedTopMarginVideo = -(screenWidth - numberChange) + "px";
    //let reducedTopMarginVideo = (monitorHeight - numberChange) * -1 + "px";

    benefitVideo.style.top = reducedTopMarginVideo;

    console.log(screenWidth);
    console.log(reducedTopMarginVideo);
  },
  true
);
*/
